import { boolean, object, ObjectSchema, string } from 'yup';

import { FormErrorMessage } from '~/constants/messages';
import { katakanaRegexp, mobilePhoneRegexp } from '~/constants/regexp';

import { Fields } from './types';

export const validationSchema: ObjectSchema<Fields> = object({
  familyName: string().label('姓').required(FormErrorMessage.required),
  givenName: string().label('名').required(FormErrorMessage.required),
  phoneticFamilyName: string()
    .label('セイ')
    .required(FormErrorMessage.required)
    .matches(katakanaRegexp, FormErrorMessage.katakana),
  phoneticGivenName: string()
    .label('メイ')
    .required(FormErrorMessage.required)
    .matches(katakanaRegexp, FormErrorMessage.katakana),
  phoneNumber: string()
    .label('携帯電話番号')
    .matches(mobilePhoneRegexp, FormErrorMessage.invalid)
    .required(FormErrorMessage.required),
  isAgree: boolean().required().oneOf([true], '利用規約及びプライバシーポリシーに同意してください'),
});
